import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca7d8aee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-tooltip__text" }


export default /*#__PURE__*/_defineComponent({
  __name: 'AppTooltip',
  props: {
    position: null,
    showArrow: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  position?: 'top' | 'bottom'
  showArrow?: boolean
};

/**
 * A basic tooltip component.
 *
 * Besides the component props, the tooltip can be further customized by overwriting the
 * `--tooltip-width` and `--tooltip-distance` CSS variables.
 *
 * `--tooltip-width` sets the width of the tooltip.
 * `--tooltip-distance` sets the distance between the tooltip and its parent.
 *
 * @param position - Whether to display the tooltip above or below it's parent.
 * @param showArrow - Whether or not to display the arrow pointing to the parent.
 */



function classes(): Record<string, boolean> {
  return {
    'app-tooltip--top': props.position === 'top',
    'app-tooltip--bottom': props.position === 'bottom',
    'app-tooltip--arrow': props.showArrow,
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["app-tooltip", classes()])
      }, [
        _createElementVNode("p", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 2)
    ]),
    _: 3
  }))
}
}

})